/* do not edit. this file is generated by npm run lib:icons and constantly overwritten */
import React from 'react'
export const SvgMagnifyingGlass = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={20}
    height={20}
    viewBox='0 0 20 20'
    xmlns='http://www.w3.org/2000/svg'
    role='img'
    {...props}
  >
    <path d='M16.0802 17.919C16.5879 18.4266 17.411 18.4266 17.9187 17.919C18.4264 17.4113 18.4264 16.5882 17.9187 16.0805L16.0802 17.919ZM14.5053 12.6671C13.9976 12.1594 13.1745 12.1594 12.6668 12.6671C12.1591 13.1748 12.1591 13.9979 12.6668 14.5056L14.5053 12.6671ZM17.9187 16.0805L14.5053 12.6671L12.6668 14.5056L16.0802 17.919L17.9187 16.0805ZM16.3686 9.03407C16.3686 4.98358 13.0851 1.7 9.03456 1.7V4.3C11.6491 4.3 13.7686 6.41952 13.7686 9.03407H16.3686ZM9.03456 1.7C4.98406 1.7 1.70049 4.98358 1.70049 9.03407H4.30049C4.30049 6.41952 6.42 4.3 9.03456 4.3V1.7ZM1.70049 9.03407C1.70049 13.0846 4.98406 16.3681 9.03456 16.3681V13.7681C6.42 13.7681 4.30049 11.6486 4.30049 9.03407H1.70049ZM9.03456 16.3681C13.0851 16.3681 16.3686 13.0846 16.3686 9.03407H13.7686C13.7686 11.6486 11.6491 13.7681 9.03456 13.7681V16.3681Z' />
  </svg>
)
export default SvgMagnifyingGlass
